import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { SettingsWelcomeChannelStyles } from '../styles/SettingsWelcomeChannelStyles';

export interface CharacterCounterProps {
  characterCount: number;
  characterLimit: number;
  newLineCount: number;
  newLineLimit: number;
}

export class CharacterCounter extends React.PureComponent<CharacterCounterProps> {
  private overCharacterLimit() {
    return this.props.characterCount > this.props.characterLimit;
  }

  private overNewLineLimit() {
    return this.props.newLineCount > this.props.newLineLimit;
  }

  render() {
    const messageProps = {
      CHARACTER_COUNT: this.props.characterCount.toString(),
      CHARACTER_LIMIT: this.props.characterLimit.toString()
    };

    const characterCount = <span className={this.overCharacterLimit() ? 'tb-form-error' : ''}>{Messages.settings_welcomeChannel_characterCount(messageProps)}</span>;
    const newLineCount = <span className={this.overNewLineLimit() ? 'tb-form-error' : ''}>{Messages.settings_welcomeChannel_newLineLimit()}</span>;

    return (
      <div style={SettingsWelcomeChannelStyles.CharacterCounterStyle}>
        {characterCount} {newLineCount}
      </div>
    );
  }
}
